import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@/store/index'

const selectAgenciesUiState = (state: RootState) => state.agenciesUi

export const selectIsCreateAgencyOpen = createSelector(
  selectAgenciesUiState,
  (ui) => ui.isCreateOpen,
)

export const selectIsEditAgencyOpen = createSelector(
  selectAgenciesUiState,
  (ui) => ui.isEditOpen,
)

export const selectEditingAgencyId = createSelector(
  selectAgenciesUiState,
  (ui) => ui.editingAgencyId,
)

export const selectAgencyFormFields = createSelector(
  selectAgenciesUiState,
  (ui) => ui.fields,
)

export const selectAgencyFormFieldErrors = createSelector(
  selectAgenciesUiState,
  (ui) => ui.fieldErrors,
)

export const selectAgencyFormSubmitError = createSelector(
  selectAgenciesUiState,
  (ui) => ui.submitError,
)

export const selectIsAgencyFormSubmitting = createSelector(
  selectAgenciesUiState,
  (ui) => ui.isSubmitting,
)

export const selectAgencyFormSlugTouched = createSelector(
  selectAgenciesUiState,
  (ui) => ui.slugTouched,
)

export const selectAgencyStatusConfirm = createSelector(
  selectAgenciesUiState,
  (ui) => ui.statusConfirm,
)

export const selectIsAgencyStatusPending = createSelector(
  selectAgenciesUiState,
  (ui) => ui.statusPending,
)

export const selectAgencyStatusError = createSelector(
  selectAgenciesUiState,
  (ui) => ui.statusError,
)
